<script lang="ts">
	import type { Coordinates } from '$lib/components/map/types';
	import Icon from '$lib/components/icons/Icon.svelte';
	import { Marker } from 'svelte-maplibre';

	interface Props {
		coordinates: Coordinates | undefined;
	}

	const { coordinates }: Props = $props();
</script>

{#if coordinates}
	<Marker lngLat={coordinates}>
		<div
			class="flex items-center justify-center h-5 w-5 shadow-electric-trip bg-electric-weakest rd-1 border-electric border-1 border-solid text-electric text-4"
		>
			<Icon icon="bolt" />
		</div>
	</Marker>
{/if}
